import { render, staticRenderFns } from "./AuthorizedSignatory.vue?vue&type=template&id=7a9a4560&"
import script from "./AuthorizedSignatory.vue?vue&type=script&lang=js&"
export * from "./AuthorizedSignatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports